import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { ADMIN_GENERAL_SETTINGS_ROUTE_NAME } from '@modules/general-settings/constants';
import { useI18n } from '@modules/i18n/composables';
import {
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

import {
  ADMIN_WELCOME_PAGE_REDIRECTS_ROUTE_NAME,
  TRANSLATION_GROUP_WELCOME_PAGE_REDIRECTS,
  WELCOME_PAGE_REDIRECTS_PERMISSIONS,
} from './constants';
import { getTranslationKeys } from './translations';

export class WelcomePageRedirectsModule extends AppModule {
  protected submodules = [];

  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: ADMIN_WELCOME_PAGE_REDIRECTS_ROUTE_NAME,
      path: 'welcome-page-redirects',
      permission: WELCOME_PAGE_REDIRECTS_PERMISSIONS.SHOW,
      component: () => import('@modules/welcome-page-redirects/pages/WelcomePageRedirectsPage/WelcomePageRedirectsPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'GENERAL_SETTINGS_WELCOME_PAGE_REDIRECTS'),
      to: {
        name: ADMIN_WELCOME_PAGE_REDIRECTS_ROUTE_NAME,
      },
      permission: WELCOME_PAGE_REDIRECTS_PERMISSIONS.SHOW,
      id: ADMIN_WELCOME_PAGE_REDIRECTS_ROUTE_NAME,
      order: 170,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_WELCOME_PAGE_REDIRECTS, getTranslationKeys);
  }
}
